//======================================================================
//  Knowledge Force Publisher Course
//======================================================================

// use 'import "@babel/polyfill";' if prototypeJs is not longer present
import "core-js/modules/es6.object.assign";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.array.of";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.string.includes";
import "core-js/modules/es6.string.starts-with";
import "core-js/modules/es6.string.ends-with";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.map";
import "core-js/modules/es6.set";
import "core-js/modules/es6.symbol";


import {CourseFactory} from "api/CourseFactory";
import {CourseActionManager} from "api/CourseActionManager";
import {CourseToPublisherScormApi} from "publisher/communication/CourseToPublisherScormApi";
import {LocalDataChangeWatcher} from "localstorage/LocalDataChangeWatcher";

if (!window.TTPortal) {
    window.TTPortal = {};
}
window.TTPortal.version = "BUILD_VERSION_REPLACEMENT_STRING";
window.TTPortal.DEBUG = false;
window.API = null;

window.CCourseFactory = CourseFactory;
window.CCourseActionManager = CourseActionManager;
window.CAcceleratorScormApi = function( query, scoId ){
    return new CourseToPublisherScormApi( query, scoId, false );
}
window.CAcceleratorScormApi = CourseToPublisherScormApi;


// legacy support for CTimer
window.CTimer = LocalDataChangeWatcher;
window.CTimer.TIMER_MODE_DEFAULT = 0;
window.CTimer.TIMER_MODE_COOKIE_CHANGE = 1;
